export default {
  presenter: 'vondra',
  title: 'Jak se zabydlet na virtuálním serveru',
  subtitle: 'začátečníci',
  text: `
Když si objednáte u nějakého poskytovatele virtuální server čili VPS, dostanete často jen
holý Linux a čeká na Vás pár úkolů, které byste měli udělat, aby Vám server dobře sloužil.
Probereme, jak si nastavit správně heslo nebo lépe autentizaci klíčem, jak si nastavit firewall,
nainstalujeme třeba Wordpress a databázi MySQL a ukážeme, jak je zabezpečit tak, aby jste se k
nim dostali Vy a ne někdo zlý.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/vondra-virt.js